import { render } from "./LanguageLearningPage.vue?vue&type=template&id=e26c8244&scoped=true"
import script from "./LanguageLearningPage.vue?vue&type=script&lang=js"
export * from "./LanguageLearningPage.vue?vue&type=script&lang=js"

import "./LanguageLearningPage.vue?vue&type=style&index=0&id=e26c8244&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e26c8244"]])

export default __exports__